"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateValue = void 0;
const react_1 = require("react");
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
function useStateValue(value, deps = [], options) {
    const [optionsRef] = (0, react_1.useState)({ current: options });
    const setNextValue = (0, react_1.useState)(value)[1];
    const depsRef = (0, react_1.useRef)(deps);
    const valueRef = (0, react_1.useRef)(value);
    optionsRef.current = options;
    const setValue = (0, react_1.useCallback)((value) => {
        var _a, _b;
        const prevValue = valueRef.current;
        if (value !== prevValue) {
            valueRef.current = value;
            setNextValue(value);
            (_b = (_a = optionsRef.current) === null || _a === void 0 ? void 0 : _a.onChange) === null || _b === void 0 ? void 0 : _b.call(_a, value, prevValue);
        }
    }, [optionsRef, setNextValue]);
    const updateValue = (0, react_1.useCallback)((updater) => {
        setValue(updater(valueRef.current));
    }, [setValue]);
    const getValue = (0, react_1.useCallback)(() => valueRef.current, []);
    (0, react_1.useEffect)(() => {
        var _a;
        if (!((options === null || options === void 0 ? void 0 : options.depsComparator) || fast_deep_equal_1.default)(depsRef.current, deps)) {
            depsRef.current = deps;
            const prevValue = valueRef.current;
            setValue(value);
            (_a = options === null || options === void 0 ? void 0 : options.onReset) === null || _a === void 0 ? void 0 : _a.call(options, value, prevValue);
            return;
        }
    }, [deps, options, setValue, value]);
    return {
        getValue,
        setValue,
        updateValue
    };
}
exports.useStateValue = useStateValue;
//# sourceMappingURL=useStateValue.js.map